import { render, staticRenderFns } from "./SpecList.vue?vue&type=template&id=28c15923&scoped=true"
import script from "./SpecList.vue?vue&type=script&lang=js"
export * from "./SpecList.vue?vue&type=script&lang=js"
import style0 from "./SpecList.vue?vue&type=style&index=0&id=28c15923&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c15923",
  null
  
)

export default component.exports